import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import CourseForm from "../component/CourseForm";
import { Link, useNavigate } from "react-router-dom";
import img2 from "../../../assets/images/small/img-2.jpg";
import axios from "axios";
import CourseService from "../../../services/KangarooServices/CourseService";
import CourseDetail from "../component/CourseDetail";
import { formatDate, formatDateTime } from "../../../Components/Common/FormatDate";
import DeleteModal from "../../../Components/Common/DeleteModal";
import toast from "react-hot-toast";

const Course = () => {
  const navigate = useNavigate();
  const [courseData, setCourseData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpenDelete, setIsOpenDelete] = useState(false);
        const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);

        const toggleDelete = () => setIsOpenDelete(!isOpenDelete);

    

  const openModal = (id) => {
    setSelectedCourseId(id);
    setIsModalOpen(true);
  };

  const toggleModal = () => setIsModalOpen(!isModalOpen);
  
    const fetchData = async () => {
      try {
        const data = await CourseService.getList({
          search: "",
          page: 1,
          pageSize: 10,
        });

        setCourseData(data);
      } catch (err) {
        console.error("ERROR:", err);
      }
    };
    useEffect(() => {

    fetchData();
  }, []);

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDelete();
  };

  const handleDelete = async () => {
      if (selectedDeleteItem) {
        try {
          await CourseService.delete(selectedDeleteItem.id);
          toast.success("Course deleted successfully");
          await fetchData();
        } catch (error) {
          toast.error(
            error?.response?.data?.message || "Failed to delete Course"
          );
        } finally {
          toggleDelete();
          setSelectedDeleteItem(null);
        }
      }
    };

  const filteredCourses = courseData.filter((course) => {
    const term = searchTerm.toLowerCase();

    const nameMatch = course.name.toLowerCase().includes(term);
    const universityMatch = course.university?.name
      .toLowerCase()
      .includes(term);
    const levelMatch = course.level.toLowerCase().includes(term);
    const descriptionMatch = course.description.toLowerCase().includes(term);

    return nameMatch || universityMatch || levelMatch || descriptionMatch;
  });

  // const handleDeleteClick = async (id) => {
  //   await CourseService.delete(id);
  //   window.location.reload();
  // };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Courses" pageTitle="Content Management" />
        <Row>
          <Col>
            <div>
              <button
                className="btn btn-success"
                onClick={() => navigate("/course/create")}
              >
                +Add Course
              </button>
            </div>
          </Col>
          <Col>
            <div className="d-md-flex justify-content-sm-end gap-2">
              <div className="search-box ms-md-2 flex-shrink-0 mb-3 mb-md-0">
                <Input
                  type="text"
                  className="form-control"
                  id="searchJob"
                  autoComplete="off"
                  placeholder="Search by name or course"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <i className="ri-search-line search-icon"></i>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          {filteredCourses?.map((item, index) => (
            <Col className="mt-4" sm={6} xl={4} key={item.id || index}>
              <Card className="mb-3 border-0 shadow-sm h-100 d-flex flex-column hover-lift transition">
                <CardHeader>
                  <div className="flex-grow-1">
                    <h4 className="mb-0 fw-semibold">{item.name}</h4>
                  </div>
                </CardHeader>

                <CardBody className="flex-grow-1 d-flex flex-column">
                  <div className="">
                    <div className="mb-2 d-flex align-items-center">
                      <i className="ri-time-line text-primary me-2"></i>
                      <span className="small">
                        <strong>Duration:</strong> {item.durationMonths} months
                      </span>
                    </div>

                    <div className="mb-2 d-flex align-items-center">
                      <i className="ri-building-line text-primary me-2"></i>
                      <span className="small">
                        <strong>University:</strong> {item.university?.name}
                      </span>
                    </div>

                    <div className="mb-3 d-flex align-items-center">
                      <i className="ri-money-dollar-circle-line text-success me-2"></i>
                      <span className="small">
                        <strong>Tuition:</strong>
                        <span className="text-success fw-semibold ms-1">
                         {formatDate(item?.tuitionFrom)} –  {formatDate(item?.tuitionTo)}
                        </span>
                      </span>
                    </div>
                  </div>
                  <hr className="text-muted" />
                  <p
                    className="card-text text-muted "
                    style={{ fontSize: "14px", lineHeight: "1.6" }}
                  >
                    {item.description.split(" ").slice(0, 30).join(" ")}
                    {item.description.split(" ").length > 30 ? "..." : ""}
                  </p>
                  <div className="d-flex justify-content-between align-content-center align-items-center pt-2">
                    <p className="text-muted  d-flex align-items-center">
                      <i className="ri-calendar-line me-1"></i>
                     
                      {formatDate(item?.createdAt)}
                    </p>
                    <div className="d-flex align-items-center ">
                      <span className="badge bg-primary bg-opacity-50 text-primary">
                        {item.level}
                      </span>
                    </div>
                  </div>
                </CardBody>

                <div className="card-footer bg-transparent  d-flex justify-content-between align-items-center ">
                  <Link
                    to={`/courses/${item.id}`}
                    className="card-link link-secondary text-decoration-none fw-semibold d-flex align-items-center"
                  >
                    View Details
                    <i className="ri-arrow-right-s-line ms-1 align-middle lh-1"></i>
                  </Link>

                  <div className="d-flex justify-content-center align-items-center gap-1">
                    <Button
                      color="btn btn-soft-warning"
                      className="btn-sm"
                      size="sm"
                      onClick={() => navigate(`/course/create/${item.id}`)}
                    >
                      <i className="ri-edit-line" />
                    </Button>
                    <Button
                      className="btn btn-soft-danger btn-sm"
                      color="danger"
                      size="sm"
                      onClick={() => handleDeleteClick(item)}
                    >
                      <i className="ri-delete-bin-5-line" />
                    </Button>
                  </div>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
        <DeleteModal
                      show={isOpenDelete}
                      onCloseClick={toggleDelete}
                      onDeleteClick={handleDelete}
                    />
      </Container>
    </div>
  );
};

export default Course;
